import React, { useEffect, useState } from 'react';
import logo from '../../assets/kvp.png'; // Updated logo for KVP Trade LTD
import './SplashScreen.css';

const SplashScreen = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 4000); // 4 seconds

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`splash-screen ${isVisible ? 'visible' : 'hidden'}`}>
      <img src={logo} alt="KVP Trade LTD Logo" className="splash-logo" />
      <div className="splash-text">
        <h1 className="splash-main">Bulk Blitz</h1>
        <p className="splash-sub">Trader’s Deal Depot</p>
      </div>
      <div className="splash-bar">
        <div className="bar-fill" />
      </div>
    </div>
  );
};

export default SplashScreen;